// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__bQcYM","form_container":"LoginPage_form_container__6Mpl8","title":"LoginPage_title__lqkcV","subtitle":"LoginPage_subtitle__Zet6Z"};